import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { DisqusModule } from 'ngx-disqus'

import { DataVisualizationPanelComponent } from 'src/app/shared/partials/data-visualization-panel/data-visualization-panel.component'
import { FeaturedCardListComponent } from 'src/app/shared/partials/featured-card-list/featured-card-list.component'
import { FeaturedCardComponent } from 'src/app/shared/partials/featured-card/featured-card.component'
import { VideoCardComponent } from 'src/app/shared/resources/video/video-card/video-card.component'
import { BreadcrumbsComponent } from '../../shared/partials/breadcrumbs/breadcrumbs.component'
import { PaginationComponent } from '../../shared/partials/pagination/pagination.component'
import { StripHtmlPipe } from '../../shared/pipes/strip-html.pipe'
import { TruncatePipe } from '../../shared/pipes/truncate.pipe'
import { AuthorCardComponent } from '../../shared/resources/author/author-card/author-card.component'
import { AuthorFilterComponent } from '../../shared/resources/author/author-filter/author-filter.component'
import { PostCardComponent } from '../../shared/resources/post/post-card/post-card.component'
import { ExpertGroupPortalRoutingModule } from './expert-group-portal.routes'
import { ExpertGroupPortalDataComponent } from './pages/expert-group-portal-data/expert-group-portal-data.component'
import { ExpertGroupPortalExpertListComponent } from './pages/expert-group-portal-expert-list/expert-group-portal-expert-list.component'
import { ExpertGroupPortalOverviewComponent } from './pages/expert-group-portal-overview/expert-group-portal-overview.component'
import { ExpertGroupPortalPostListComponent } from './pages/expert-group-portal-post-list/expert-group-portal-post-list.component'
import { ExpertGroupPortalResourcesListComponent } from './pages/expert-group-portal-resources-list/expert-group-portal-resources-list.component'
import { ExpertGroupPortalVideoListComponent } from './pages/expert-group-portal-video-list/expert-group-portal-video-list.component'
import { FuturesExplorerComponent } from './pages/futures-explorer/futures-explorer.component'
import { ExpertGroupPortalHeaderComponent } from './partials/expert-group-portal-header/expert-group-portal-header.component'
import { ExpertGroupPortalResourcesTabsComponent } from './partials/expert-group-portal-resources-tabs/expert-group-portal-resources-tabs.component'
import { ExpertListLoaderComponent } from './partials/loaders/expert-list-loader.component'
import { OverviewDiscussionLoaderComponent } from './partials/loaders/overview-discussion-loader.component'
import { OverviewExpertLoaderComponent } from './partials/loaders/overview-experts-loader.component'
import { OverviewSectionLoaderComponent } from './partials/loaders/overview-section-loader.component'
import { ResourcesLoaderComponent } from './partials/loaders/resources-loader.component'
import { DiscussionCardComponent } from './resources/discussion/discussion-card/discussion-card.component'
import { DiscussionDetailComponent } from './resources/discussion/discussion-detail/discussion-detail.component'
import { DiscussionListComponent } from './resources/discussion/discussion-list/discussion-list.component'

@NgModule({
  declarations: [
    ExpertGroupPortalExpertListComponent,
    ExpertGroupPortalOverviewComponent,
    ExpertGroupPortalResourcesListComponent,
    ExpertGroupPortalVideoListComponent,
    ExpertGroupPortalHeaderComponent,
    ExpertGroupPortalResourcesTabsComponent,
    ExpertGroupPortalDataComponent,
    ExpertGroupPortalPostListComponent,
    DiscussionCardComponent,
    DiscussionDetailComponent,
    DiscussionListComponent,
    FuturesExplorerComponent
  ],
  imports: [
    CommonModule,
    ExpertGroupPortalRoutingModule,
    DisqusModule,

    // Standalone.
    AuthorFilterComponent,
    BreadcrumbsComponent,
    AuthorCardComponent,
    PaginationComponent,
    PostCardComponent,
    VideoCardComponent,
    FeaturedCardComponent,
    FeaturedCardListComponent,
    BreadcrumbsComponent,
    DataVisualizationPanelComponent,
    TruncatePipe,
    StripHtmlPipe,

    // Loaders.
    OverviewDiscussionLoaderComponent,
    OverviewExpertLoaderComponent,
    OverviewSectionLoaderComponent,
    ResourcesLoaderComponent,
    ExpertListLoaderComponent
  ]
})
export class ExpertGroupPortalModule {}
